import { NavLink } from 'react-router-dom'

const navItems = [
  { to: '/health', label: 'Health' },
  { to: '/entities', label: 'Entities' },
  { to: '/journal', label: 'Journal' },
  { to: '/maintenance', label: 'Maintenance' },
  { to: '/wake', label: 'Wake' },
  { to: '/relational', label: 'Relational Arc' },
  { to: '/sparrow', label: 'Sparrow Ops' },
]

export default function Header() {
  return (
    <header className="flex items-center justify-between px-8 py-4 border-b border-mm-border bg-mm-black/95 backdrop-blur-xl sticky top-0 z-50">
      {/* Logo */}
      <div className="flex items-center gap-4">
        <div className="text-xl tracking-wide">
          <span className="font-glacial-bold text-mm-viridian">Mind</span>
          <span className="font-glacial-bold text-mm-parchment"> Mirror</span>
        </div>
        <span className="text-mm-parchment/50 text-[13px] tracking-wider hidden sm:inline">
          Cloud Mind Dashboard
        </span>
      </div>

      {/* Nav Pills */}
      <nav className="flex gap-0.5">
        {navItems.map(({ to, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `px-4 py-1.5 rounded-md text-[13px] transition-all duration-200 border border-transparent ${
                isActive
                  ? 'text-mm-sage bg-mm-sage/[0.08] border-mm-sage/20 font-glacial-bold glow-sage'
                  : 'text-mm-parchment/50 hover:text-mm-parchment hover:bg-mm-card'
              }`
            }
          >
            {label}
          </NavLink>
        ))}
      </nav>

      {/* Role Indicator */}
      <div className="flex items-center gap-2 text-[13px] text-mm-parchment/50">
        <div className="w-2 h-2 rounded-full bg-mm-viridian glow-viridian" />
        Courtney — Admin
      </div>
    </header>
  )
}
